import React, { useEffect, useState } from 'react';
import { isIOS } from 'react-device-detect';
import LocalLoader from '../../Shared/LocalLoader/LocalLoader';
import helper from '../../../utilities/helper';

const OpenCellcomApp = (props) => {
  const title = props.iContent?.mainTitle?.value;
  const [loading, setLoading] = useState(false);
  let appOpened = false;
  let popupOpened = false;
  let timeoutId;

  const handleOpenApp = () => {
    setLoading(true);
    const hash = helper.getUrlParameter("hash");
    const clmId = helper.getUrlParameter("clmId");
    const clmUuid = helper.getUrlParameter("clmUuid");
    const connectTokenToClientName = helper.getUrlParameter("connectTokenToClientName");
    const isAbroad = helper.getUrlParameter("isAbroad") || false;

    console.info("hash", hash);
    console.info("clmId", clmId);
    console.info("clmUuid", clmUuid);
    console.info("connectTokenToClientName", connectTokenToClientName);
    console.info("isAbroad", isAbroad);
    const appUrl = `cellcomApp://selfcare/app/esim?hash=${hash}&clmId=${clmId}&clmUuid=${clmUuid}&connectTokenToClientName=${connectTokenToClientName}&isAbroad=${isAbroad}`;

    const handleBlur = () => {
      popupOpened = true;
    };

    const handleFocus = () => {
      if (popupOpened && !appOpened) {
        console.log("האפליקציה לא מותקנת! נפנה לחנות...");
      }
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        appOpened = true;
        clearTimeout(timeoutId);
      }
    };

    window.addEventListener("blur", handleBlur);
    window.addEventListener("focus", handleFocus);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    window.location.href = appUrl;

    timeoutId = setTimeout(() => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("blur", handleBlur);
      window.removeEventListener("focus", handleFocus);
      setLoading(false);

      if (!appOpened) {
        const appStoreLink = isIOS ? "https://apps.apple.com/us/app/whatsapp-messenger/id310633997" : "https://play.google.com/store/apps/details?id=com.whatsapp";
        window.location.href = appStoreLink;
      }
    }, 2500);
  };

  useEffect(() => {
    handleOpenApp();
  }, []);

  return (
    <div className="check-cellcom-app">
      {loading && (
        <>
          <LocalLoader />
          {title && <h2>{title}</h2>}
        </>
      )}
    </div>
  );
};

export default OpenCellcomApp;
